export const customerServiceZH = {
  customer1: '你好，我是Bloom智能客服，请向我描述问题，我会尽我所能帮助到你～',
  customer2: '你好，我是Bloom智能客服，你可以向我咨询平台使用或活动规则等问题，我会尽我所能为你解答～',
  customer3: '以上都不是我想要咨询的问题',
  customer4: '很抱歉我没能理解问题，你可以重新向我描述问题，或者点击下方文字，进入留言咨询页面，将有人工为你解答',
  customer5: '前往留言咨询',
  customer6: 'Bloom智能客服正在回复中，请稍后再次提问～',
  customer7: '已解决',
  customer8: '未解决',
  customer9: '常见问题 ',
  customer10: 'AI客服',
  customer11: '联系人工',
  customer12: '我要投诉',
  customer13: '请输入...',
  customer14: '我',
  customer15: '客服',
  customer16: '其他与本次咨询相关的问题：',
  customer17: '正在思考中，请稍等',
  customer18: '已为您跳转至留言咨询页面，请点击「发起咨询」按钮进行留言～',
  customer19: '已为您跳转至联系页面，请根据页面中的联系方式来联系我们～',
  customer20: '暂不支持表情哦~',
  customer21: 'AI客服处理问题中...'
}

export const customerServiceEN = {
  customer1: 'Hello! I\'m Bloom AI Customer Service. Please describe your issue, and I\'ll do my best to help.',
  customer2: 'Hello! I\'m Bloom AI Customer Service. You can ask me about platform usage or activity rules. I\'ll do my best to help!',
  customer3: 'None of these match my issue',
  customer4: 'I\'m sorry I couldn\'t understand your question. You can:' + '\n' + '• Rephrase your question, or' + '\n' + '• Message Us for human support',
  customer5: 'Message Us',
  customer6: 'Bloom AI Customer Service is replying... Please ask again later.',
  customer7: 'Resolved',
  customer8: 'Unresolved',
  customer9: 'FAQs',
  customer10: 'AI Customer Service',
  customer11: 'Contact Us',
  customer12: 'Submit a Complaint',
  customer13: 'Type a message... ',
  customer14: 'Me',
  customer15: 'Customer service',
  customer16: 'Related ticket issues：',
  customer17: 'Generating a response, please wait',
  customer18: 'You\'re on the Message Us page. Please click \'New Ticket\' to leave a message.',
  customer19: 'You have been redirected to the contact page. Please use the contact details provided to reach out to us.',
  customer20: 'Emojis are not supported',
  customer21: 'AI Customer Service is processing your inquiry...'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/customerService.js